export const colorsInverted = {
  redInverted: 'bg-backgroundRed text-contentRed border border-contentRed',
  orangeInverted: 'bg-backgroundOrange text-contentOrange border border-contentOrange',
  amberInverted: 'bg-backgroundAmber text-contentAmber border border-contentAmber',
  yellowInverted: 'bg-backgroundYellow text-contentYellow border border-contentYellow',
  limeInverted: 'bg-backgroundLime text-contentLime border border-contentLime',
  greenInverted: 'bg-backgroundGreen text-contentGreen border border-contentGreen',
  emeraldInverted: 'bg-backgroundEmerald text-contentEmerald border border-contentEmerald',
  tealInverted: 'bg-backgroundTeal text-contentTeal border border-contentTeal',
  cyanInverted: 'bg-backgroundCyan text-contentCyan border border-contentCyan',
  skyInverted: 'bg-backgroundSky text-contentSky border border-contentSky',
  blueInverted: 'bg-backgroundBlue text-contentBlue border border-contentBlue',
  indigoInverted: 'bg-backgroundIndigo text-contentIndigo border border-contentIndigo',
  violetInverted: 'bg-backgroundViolet text-contentViolet border border-contentViolet',
  purpleInverted: 'bg-backgroundPurple text-contentPurple border border-contentPurple',
  fuchsiaInverted: 'bg-backgroundFuchsia text-contentFuchsia border border-contentFuchsia',
  pinkInverted: 'bg-backgroundPink text-contentPink border border-contentPink',
  roseInverted: 'bg-backgroundRose text-contentRose border border-contentRose'
}

export const colors = {
  default: 'bg-backgroundGray text-contentTertiary border border-borderPrimary',
  tertiary: 'bg-backgroundTertiary text-contentTertiary border border-borderPrimary',
  secondary: 'bg-backgroundSecondary text-contentSecondary border border-borderSecondary',

  // dark
  zinc: 'bg-contentTertiary text-backgroundGray',
  red: 'bg-contentRed text-backgroundRed',
  orange: 'bg-contentOrange text-backgroundOrange',
  yellow: 'bg-contentYellow text-backgroundYellow',
  lime: 'bg-contentLime text-backgroundLime',
  green: 'bg-contentGreen text-backgroundGreen',
  emerald: 'bg-contentEmerald text-backgroundEmerald',
  teal: 'bg-contentTeal text-backgroundTeal',
  cyan: 'bg-contentCyan text-backgroundCyan',
  sky: 'bg-contentSky text-backgroundSky',
  blue: 'bg-contentBlue text-backgroundBlue',
  indigo: 'bg-contentIndigo text-backgroundIndigo',
  violet: 'bg-contentViolet text-backgroundViolet',
  purple: 'bg-contentPurple text-backgroundPurple',
  fuchsia: 'bg-contentFuchsia text-backgroundFuchsia',
  pink: 'bg-contentPink text-backgroundPink',
  rose: 'bg-contentRose text-backgroundRose',
  amber: 'bg-contentAmber text-backgroundAmber',
  // light
  ...colorsInverted,

  // TODO: tags
  category: 'bg-contentIndigo text-backgroundIndigo',
  skill: 'bg-backgroundIndigo text-contentIndigo border border-contentIndigo',

  // collection/article publication badges
  gray: 'bg-backgroundGray text-contentZinc border border-borderPrimary',
  transparent: 'bg-transparent text-contentZinc border border-transparent',

  darkBlue: 'bg-blue-600 text-contentInversePrimary border border-transparent'
}
